import React, { lazy, PropsWithChildren, Suspense, useMemo } from "react";
import { BrowserRouter } from "react-router-dom";
import { CompatRouter } from "react-router-dom-v5-compat";
import { isCorpTenant } from "@capone/common";
import {
  AVAILABLE,
  CORE_CARS,
  CORE_HOTELS,
  getExperimentVariant,
  useExperiments,
} from "../../../context/experiments";
import { config } from "../../../api/config";

export const BaseProviders: React.FC<PropsWithChildren> = ({ children }) => {
  const expState = useExperiments();

  const showCoreCars = getExperimentVariant(
    expState.experiments,
    CORE_CARS
  ).startsWith(AVAILABLE);

  const showCoreHotels = getExperimentVariant(
    expState.experiments,
    CORE_HOTELS
  ).startsWith(AVAILABLE);

  const PortalComponent = useMemo(() => {
    if (!showCoreCars && !showCoreHotels) return null;

    if (isCorpTenant(config.TENANT)) {
      return lazy(() => import("../CorporatePortal"));
    }
    return lazy(() => import("../Portal"));
  }, [showCoreCars, showCoreHotels]);

  if (PortalComponent) {
    return (
      <Suspense fallback="loading">
        <PortalComponent>{children}</PortalComponent>
      </Suspense>
    );
  }

  return (
    <BrowserRouter>
      <CompatRouter>{children}</CompatRouter>
    </BrowserRouter>
  );
};
